import React from 'react'
import QuillEditorContainer from '../../../../Components/Miscellaneous/Editor/QuillEditor'

export default function QuillEditor() {
    return (
        <div className='page-body'>
            <QuillEditorContainer />
        </div>
    )
}
